"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TraditionalLogin = void 0;
const react_1 = __importDefault(require("react"));
const Button_1 = require("@food/ui/build/dist/src/Button");
const Field_1 = require("@food/ui/build/dist/src/Field");
const SocialLogin_1 = require("./SocialLogin");
const css_manager_1 = require("@food/css-manager");
const flexRow = (0, css_manager_1.registerClass)(() => `
	flex-direction: row;
`);
const flexCol = (0, css_manager_1.registerClass)(() => `
	flex-direction: column;
`);
const stepSection = (0, css_manager_1.registerClass)((theme, sc) => `
	padding: ${(theme.ratios.l / 4) * theme.font.baseSize}px ${theme.ratios.l *
    theme.font.baseSize}px;

	> div {
		display: flex;
		justify-content: space-between;

		> div {
			margin: ${(theme.ratios.l / 2) * theme.font.baseSize}px;
			flex-grow: 1;
		}
	}
	
	.${sc('renew-email')} {
		font-weight: ${theme.font.weights.semibold}
	}
	
	.${sc('renew-intro')} {
		margin: 1em;
		text-align: center;
	}
	
	.${sc('change-login-type')} {
		text-align: center;
		margin-bottom: ${theme.ratios.xs * theme.font.baseSize}px;
	}
	
	.${sc('reset-password-link')} {
		text-align: center;
	}
	
	.${sc('login-buttons')} {
		text-align: center;

		>button {
			margin: ${(theme.ratios.xl / 2) * theme.font.baseSize}px;
		}
	}
	
	&.${sc('layout', 'STANDARD')} > div > div {
		flex-basis: ${theme.font.baseSize}px;
		display: flex;
		flex-direction: column;
		justify-content: center;
	}
`);
const sc = (...args) => (0, css_manager_1.subClass)(stepSection, ...args);
const marginBottom = (0, css_manager_1.registerClass)((theme) => `margin-bottom: ${theme.ratios.l * theme.font.baseSize}px;`);
class TraditionalLogin extends react_1.default.Component {
    constructor(props) {
        super(props);
        this.setter = (field) => (event) => {
            const news = {};
            news[field] = event.target.value;
            this.setState((prev) => ({ ...prev, ...news }));
        };
        this.state = {
            email: props.isRenew && props.fixedEmail ? props.fixedEmail : '', // FIXME - '' not allowed
            password: '', // FIXME - '' not allowed
        };
    }
    render() {
        const { email, password } = this.state;
        const { onLogin, loading, logoElem, errors, t, changePhase, isRenew, layout, orLogout, } = this.props;
        if (loading) {
            return (react_1.default.createElement("section", null,
                t `loading`,
                "..."));
        }
        return (react_1.default.createElement(react_1.default.Fragment, null,
            react_1.default.createElement("h2", null, t(isRenew ? 'Renew your authentication' : 'Sign In / Register')),
            react_1.default.createElement("section", { className: (0, css_manager_1.classNames)(stepSection, sc('layout', layout)) },
                react_1.default.createElement("div", { className: layout === SocialLogin_1.SOCIAL_LOGIN_LAYOUTS.STANDARD
                        ? flexRow
                        : flexCol },
                    logoElem,
                    react_1.default.createElement("div", null,
                        react_1.default.createElement("div", { className: isRenew ? sc('renew-intro') : '' },
                            isRenew && (react_1.default.createElement(react_1.default.Fragment, null,
                                t `Insert the password to renew as`,
                                ' ',
                                react_1.default.createElement("span", { className: sc('renew-email') }, email),
                                ":")),
                            !isRenew && react_1.default.createElement(react_1.default.Fragment, null,
                                t `Use the credentials we gave you`,
                                ":")),
                        errors,
                        react_1.default.createElement("div", { className: marginBottom },
                            react_1.default.createElement("form", { onSubmit: () => onLogin({ email, password }) },
                                react_1.default.createElement(Field_1.Field, null,
                                    react_1.default.createElement("input", { disabled: isRenew, type: isRenew ? 'hidden' : 'email', placeholder: "you@domain.com", value: email, onChange: this.setter('email'), onKeyPress: (e) => {
                                            if (e.key === 'Enter' &&
                                                email &&
                                                password) {
                                                onLogin({ email, password });
                                            }
                                        } })),
                                react_1.default.createElement(Field_1.Field, null,
                                    react_1.default.createElement("input", { type: "password", placeholder: "password", value: password, onChange: this.setter('password'), onKeyPress: (e) => {
                                            if (e.key === 'Enter' &&
                                                email &&
                                                password) {
                                                onLogin({ email, password });
                                            }
                                        } })),
                                react_1.default.createElement("div", { className: sc('login-buttons') },
                                    react_1.default.createElement(Button_1.Button, { disabled: !email || !password, label: t(isRenew ? 'Renew' : 'Sign In'), type: "success", onClick: () => {
                                            onLogin({ email, password });
                                        } }),
                                    isRenew && (react_1.default.createElement(Button_1.Button, { type: 'alt', onClick: orLogout, layout: Button_1.layouts.LINK, label: t `... or Logout` }))))),
                        !isRenew && (react_1.default.createElement("div", { className: sc('change-login-type') },
                            react_1.default.createElement(Button_1.Button, { label: t `Sign In with your social account`, layout: Button_1.layouts.LINK, onClick: () => {
                                    changePhase('LOGIN');
                                } }))),
                        react_1.default.createElement("div", { className: sc('reset-password-link') },
                            react_1.default.createElement(Button_1.Button, { label: t `Reset your password`, layout: Button_1.layouts.LINK, onClick: () => {
                                    this.props.onPasswordResetLink?.();
                                } })))))));
    }
}
exports.TraditionalLogin = TraditionalLogin;
//# sourceMappingURL=TraditionalLogin.js.map